import classNames from 'classnames';

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('check-icon', className);

  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      className={classes}
      {...attributes}
    >
      <path
        d="M16.6963 8.53033C16.9892 8.23744 16.9892 7.76256 16.6963 7.46967C16.4035 7.17678 15.9286 7.17678 15.6357 7.46967L10.166 12.9393L7.69635 10.4697C7.40345 10.1768 6.92858 10.1768 6.63569 10.4697C6.34279 10.7626 6.34279 11.2374 6.63569 11.5303L9.63568 14.5303C9.92858 14.8232 10.4035 14.8232 10.6963 14.5303L16.6963 8.53033Z"
        fill="#92C02F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.90866 0.25C7.91409 0.25 6.96027 0.645088 6.25701 1.34835L2.01437 5.59099C1.3111 6.29425 0.916016 7.24808 0.916016 8.24264V13.7574C0.916016 14.7519 1.3111 15.7057 2.01437 16.409L6.25701 20.6516C6.96027 21.3549 7.91409 21.75 8.90866 21.75H14.4234C15.4179 21.75 16.3718 21.3549 17.075 20.6516L21.3177 16.409C22.0209 15.7057 22.416 14.7519 22.416 13.7574V8.24264C22.416 7.24808 22.0209 6.29425 21.3177 5.59099L17.075 1.34835C16.3718 0.645088 15.4179 0.25 14.4234 0.25H8.90866ZM7.31767 2.40901C7.73962 1.98705 8.31192 1.75 8.90866 1.75H14.4234C15.0201 1.75 15.5924 1.98705 16.0144 2.40901L20.257 6.65165C20.679 7.07361 20.916 7.6459 20.916 8.24264V13.7574C20.916 14.3541 20.679 14.9264 20.257 15.3483L16.0144 19.591C15.5924 20.0129 15.0201 20.25 14.4234 20.25H8.90866C8.31192 20.25 7.73962 20.0129 7.31767 19.591L3.07503 15.3483C2.65307 14.9264 2.41602 14.3541 2.41602 13.7574V8.24264C2.41602 7.6459 2.65307 7.07361 3.07503 6.65165L7.31767 2.40901Z"
        fill="#92C02F"
      />
    </svg>
  );
};

export default CheckIcon;
